import { of } from "rxjs";
import { filter, switchMap } from "rxjs/operators";
import { selectIsModalOpen } from "../../../../selectors/selectModalTabId";
import { selectSelectedQuest } from "../../../../selectors/selectQuestInfo";
import { IdModal } from "../../../modals/IdModal";
import { TypeActionQuestInfo } from "../actionQuestInfo";
import { actionQuestSelect } from "../list/actionQuests";
export var epicQuestUpdateSelectedQuest = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return ((action.type === TypeActionQuestInfo.Update ||
            action.type === TypeActionQuestInfo.Skip) &&
            selectIsModalOpen(state$.value, IdModal.Quests));
    }), switchMap(function () {
        var state = state$.value;
        var selectedQuest = selectSelectedQuest(state);
        return of(actionQuestSelect(selectedQuest));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/epics/epicQuestUpdateSelectedQuest.ts
// module id = 1971
// module chunks = 3